import './projectsBrowse.scss';
import * as React from 'react';
import { BlogPostCard } from '../../components/blog/blogPost';
import { Breadcrumbs } from '../../components/layout/breadcrumbs';
import { SectionTitle } from '../../components/layout/sectionTitle';
import { BackToTop } from '../../components/layout/shell/backToTop';
import Footer from '../../components/layout/shell/footer';
import { View } from '../../components/layout/view';
import { Pagination } from '../../components/navigation/pagination';
import { ProjectCard } from '../../components/project/projectCard';
import { ProjectListItem } from '../../components/project/projectListItem';
import { ProjectTagsMenu } from '../../components/project/projectTagsMenu';
import { icons } from '../../content/icons';
import { useNoHero } from '../../hooks/useHeaderFade';
import { RoutePaths } from '../../routes';
export const ProjectsTemplate = ({ pageContext }) => {
    const { group, index, pageCount, additionalContext } = pageContext;
    const projects = group.reduce((output, project) => ({
        featured: [...output.featured, ...(project.featured ? [project] : [])],
        notFeatured: [...output.notFeatured, ...(project.featured ? [] : [project])],
    }), { featured: [], notFeatured: [] });
    useNoHero();
    return (<View noHero title="Projects" className="projects">
      {additionalContext?.projectType && (<>
          <Breadcrumbs tags={[{ content: additionalContext.projectType.name, iconTicket: additionalContext.projectType.icon?.[0].ticket }]} cancel={additionalContext?.projectType && { to: RoutePaths.projects.projectsBrowse(), text: 'cancel filters' }} expandable={{
        openText: 'change type',
        closeText: 'close',
        openIcon: icons.edit,
        closeIcon: icons.cancel,
    }}>
            <ProjectTagsMenu />
          </Breadcrumbs>

          <SectionTitle title={additionalContext.projectType.name} description={index === 1 && additionalContext.projectType.description} titleImageTicket={additionalContext?.projectType?.icon?.[0]?.ticket}/>
        </>)}

      {additionalContext?.projectSize && (<>
          <Breadcrumbs crumbs={[
        { title: 'Projects', to: RoutePaths.projects.projectsBrowse(), icon: icons.back },
        { title: additionalContext.projectSize.name },
    ]}>
            <ProjectTagsMenu />
          </Breadcrumbs>

          <SectionTitle title={additionalContext.projectSize.name} description={index === 1 && additionalContext.projectSize.description}/>
        </>)}

      {additionalContext?.projectVertical && (<>
          <Breadcrumbs crumbs={[
        { title: 'Projects', to: RoutePaths.projects.projectsBrowse(), icon: icons.back },
        { title: additionalContext.projectVertical.name },
    ]}>
            <ProjectTagsMenu />
          </Breadcrumbs>

          <SectionTitle title={additionalContext.projectVertical.name} description={index === 1 && additionalContext.projectVertical.description}/>
        </>)}

      {!additionalContext?.projectType && !additionalContext?.projectSize && !additionalContext?.projectVertical && (<SectionTitle title="All Projects"/>)}

      <Pagination currentPage={index} totalPages={pageCount} newUrl={(newPage) => additionalContext?.projectType
        ? RoutePaths.projects.projectType(additionalContext?.projectType, newPage)
        : RoutePaths.projects.projectsBrowse(newPage)}/>

      {!!projects.featured.length && (<div className="projects-list">
          {projects.featured.map((project) => (<ProjectListItem project={project} key={project.client_name}/>))}
        </div>)}

      {!!projects.notFeatured.length && (<div className="projects-list">
          {projects.notFeatured.map((project) => (<ProjectCard project={project} key={project.client_name}/>))}
        </div>)}

      <Pagination currentPage={index} totalPages={pageCount} newUrl={(newPage) => additionalContext?.projectType
        ? RoutePaths.projects.projectType(additionalContext?.projectType, newPage)
        : RoutePaths.projects.projectsBrowse(newPage)}/>

      {!!additionalContext.blogPosts?.length && (<div className="blog-posts">
          <SectionTitle title="Blog Posts"/>

          {additionalContext.blogPosts?.map((blogPost) => (<BlogPostCard blogPost={blogPost}/>))}
        </div>)}

      {index === pageCount && <ProjectTagsMenu title={additionalContext.projectType ? 'check out a different topic' : 'browse by what we did'}/>}

      <BackToTop />
      <Footer />
    </View>);
};
export default ProjectsTemplate;
